import React, {Fragment} from 'react'
import axios from 'axios'
import {Button, Input, Alert} from "reactstrap"
import _pull from 'lodash/pull'
import MoreOptions from "./MoreOptions";
import moment from "moment";

export default class RentalProposalLayout extends React.Component {
    constructor(props) {
        super(props)
        axios.defaults.headers.common['Accept'] = 'application/json'
        this.state = {
            saving: false,
            models: [],
            more: [],
        }
    }

    handleCheck = e => {
        const {offers, params} = this.props
        const [offer_id, car_id] = e.target.value.split('_')
        const offer = offers.find(o => o.id === parseInt(offer_id))
        if (e.target.checked) {
            const model = {
                id: e.target.value,
                offer_id,
                car_id,
                daily: offer.daily,
                start_date: params.start_date,
                start_hour: params.start_hour,
                end_date: params.end_date,
                end_hour: params.end_hour,
                insurance_type: String(params.insurance_type),
                insurance: offer.insurances[`i${params.insurance_type}`],
                deposit: offer.insurances[`d${params.insurance_type}`],
            }
            this.setState({models: this.state.models.concat(model)})
        } else
            this.setState({
                models: this.state.models.filter(m => m.id !== e.target.value),
                more: _pull(this.state.more, e.target.value)
            })
    }

    handleMore = id => {
        if (this.state.more.includes(id))
            this.setState({more: _pull(this.state.more, id)})
        else
            this.setState({more: this.state.more.concat(id)})
    }

    handleDateChange = (key, id, date) => {
        this.setState({models: this.state.models.map(m => m.id === id ? {...m, [key]: date} : m)})
    }


    handleChange = e => {
        const [key, id] = e.target.name.split('-')
        let change = {[key]: e.target.value}
        if(key === 'insurance_type'){
            const [offer_id, car_id] = id.split('_')
            const insurances = this.props.offers.find(o => o.id === parseInt(offer_id)).insurances
            const insurance = insurances[`i${e.target.value}`]
            const deposit = insurances[`d${e.target.value}`]
            change = {insurance_type: e.target.value, insurance, deposit}
        }
        this.setState({models: this.state.models.map(m => m.id === id ? {...m, ...change} : m)})
    }

    queryObject = () => {

        return {
            authenticity_token: CSRF_TOKEN,
            models: this.state.models
        }
    }
    handleSubmit = () => {
        this.setState({saving: true, error: null})
        const that = this
        axios.post(`/dashboard/reservations/${this.props.reservation_id}/update_alternatives`, this.queryObject())
            .then(function (res) {
                if (res.data && res.data.success) {
                    window.location = `/dashboard/reservations/${that.props.reservation_id}`
                }
                else {
                    that.setState({error: 'Oferta nu a putut fi trimisa.', saving: false})
                }
            })
    }


    render() {
        const {models, more} = this.state
        return (
            <div>
                {this.props.offers.map(offer =>
                    offer.models.map(car => {
                            const id = `${offer.id}_${car.id}`
                            const model = models.find(m => m.id === id)
                            return (
                                <div className={'mb-4'} key={id}>
                                    <div className={'row'}>
                                        <div className={'col-12 col-sm-6 mb-2'}>
                                            <span className={'fancy-checkbox'}>
                                                <label htmlFor={`car-${car.id}`}>
                                                    <input
                                                        type={'checkbox'}
                                                        name={`car-${car.id}`}
                                                        id={`car-${car.id}`}
                                                        value={id}
                                                        onChange={this.handleCheck}
                                                    />
                                                    <span>
                                                        {!model && car.name}
                                                        {model && <b>{car.name}</b>}
                                                    </span>
                                                </label>
                                            </span>
                                        </div>
                                        <div className={'col-12 col-sm-4 mb-2'}>
                                            Pret:{' '}
                                            {!model && offer.daily}
                                            {model &&
                                            <Input
                                                type={'text'} inputMode={'decimal'}
                                                name={`daily-${id}`}
                                                value={model.daily}
                                                onChange={this.handleChange}
                                                className={'d-inline'}
                                                style={{width: 100}}
                                            />}
                                            {' '}EUR/zi
                                        </div>
                                        <div className={'col-12 col-sm-2 mb-2 text-right'}>
                                            {model &&
                                            <Button outline color={'primary'} size={'sm'}
                                                    onClick={() => this.handleMore(id)}>
                                                Optiuni
                                                <i className={`fa fa-angle-${more.includes(id) ? 'up' : 'down'} ml-1 font-weight-bold`}/>
                                            </Button>}
                                        </div>
                                    </div>
                                    {model && more.includes(id) &&
                                    <MoreOptions
                                        model={model}
                                        id={id}
                                        params={this.props.params}
                                        handleDateChange={this.handleDateChange}
                                        handleChange={this.handleChange}/>}
                                    <hr/>
                                </div>
                            )
                        }
                    )
                )}
                <div className={'text-center'}>
                    {this.state.error &&<Alert color={'danger'}>{this.state.error}</Alert>}
                    <Button className={'btn btn-success btn-lg'} onClick={this.handleSubmit} disabled={this.state.saving}>Trimite oferta</Button>
                </div>
            </div>
        )
    }
}